import axios from 'axios';

async function getScore(token: string): Promise<number> {
  try {
    const { data } = await axios({
      method: 'post',
      url: 'https://ff00ghf8ca.execute-api.us-east-1.amazonaws.com/recaptcha/verify',
      params: {
        token,
      },
    });

    return data.score;
  } catch (error) {
    console.error(error);

    return 0;
  }
}

export const recaptchaService = {
  getScore,
};
